var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.openedForce || (_vm.active && _vm.opened))?_c('div',[(_vm.current)?_c('tutorial-step',{key:_vm.current.id,attrs:{"step":_vm.current,"progress":_vm.current.progress,"with-prev":_vm.current.withPrev,"with-next":_vm.current.withNext},on:{"prev":_vm.prev,"next":_vm.next,"close":_vm.close}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }